import type { HTMLAttributes } from 'react'

import clsx from 'clsx'
import { Param } from 'shared/search-adapters'
import { Button, StackIcon } from 'shared/ui'
import { FilterTags } from 'shared/ui/Tags'

import { $modalMode, Mode } from '../Filters/store'
import { Search } from '../SearchInput/Search'
import css from './FilterHeader.module.scss'

const ORDER = [
	Param.Distance,
	Param.Locations,
	Param.LastContacted,
	Param.Campaigns,
	Param.Created,
	Param.Premium,
	Param.Avatar,
	Param.LinkedInQualification,
	Param.NotCampaigns,
	Param.NotContacted,
	Param.NotCreated,
	Param.NotLinkedInQualification,
	Param.NotAvatar
]

const MODAL_ORDER = ORDER.with(-1, Param.ModalLinkedInQualification)

const openContacts = () => $modalMode.set(Mode.Contacts)

export function FilterHeader({
	children,
	className,
	hideSearchAndFilters = false,
	isModal = false
}: Pick<HTMLAttributes<HTMLDivElement>, 'children' | 'className'> & {
	hideSearchAndFilters?: boolean
	isModal?: boolean
}) {
	return (
		<div className={clsx(css.root, className)}>
			{!hideSearchAndFilters && <Search isModal={isModal} />}
			{!hideSearchAndFilters && (
				<div className={css.filters}>
					<Button className={css.filter} onClick={openContacts}>
						<StackIcon icon='filters' width={12} />
						Filters
					</Button>
					<FilterTags order={isModal ? MODAL_ORDER : ORDER} />
				</div>
			)}
			{children}
		</div>

	)
}
